var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMensagemBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H2.5C1.125 0 0.0125 1.125 0.0125 2.5L0 25L5 20H22.5C23.875 20 25 18.875 25 17.5V2.5C25 1.125 23.875 0 22.5 0ZM6.25 8.75H18.75C19.4375 8.75 20 9.3125 20 10C20 10.6875 19.4375 11.25 18.75 11.25H6.25C5.5625 11.25 5 10.6875 5 10C5 9.3125 5.5625 8.75 6.25 8.75ZM13.75 15H6.25C5.5625 15 5 14.4375 5 13.75C5 13.0625 5.5625 12.5 6.25 12.5H13.75C14.4375 12.5 15 13.0625 15 13.75C15 14.4375 14.4375 15 13.75 15ZM18.75 7.5H6.25C5.5625 7.5 5 6.9375 5 6.25C5 5.5625 5.5625 5 6.25 5H18.75C19.4375 5 20 5.5625 20 6.25C20 6.9375 19.4375 7.5 18.75 7.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensagemBold);
export default __webpack_public_path__ + "static/media/mensagemBold.cb752d826a9887d46cc2cf20271ef23d.svg";
export { ForwardRef as ReactComponent };